import { Grid, SvgIcon } from "@mui/material"
import { Tooltip, Typography } from "@synapse-analytics/synapse-ui"
import Avatar from "boring-avatars"
import moment from "moment"

import styles from "./KonanAvatar.module.scss"

interface Props {
  createdBy: string
  title?: string | React.ReactElement
  createdAt?: string
  description?: string
  avatarName?: string
  noWrap?: boolean
  avatarSize?: number
}

// TODO:: remove and use SUI's avatar when it's finished
export function KonanAvatarComponent(props: Readonly<Props>): React.ReactElement {
  const { createdBy, createdAt, title, description, avatarName, noWrap = true, avatarSize = 24 } = props

  return (
    <Grid container spacing={1} item alignItems="center" display="flex" flexWrap="nowrap" maxWidth={"calc(100%)"}>
      <Grid item sx={{ marginTop: "2px" }} display="flex" alignItems="center">
        <SvgIcon className={styles.avatar}>
          <Avatar
            size={avatarSize}
            name={avatarName ?? createdBy ?? title}
            variant="bauhaus"
            colors={["#92A1C6", "#146A7C", "#F0AB3D", "#C271B4", "#C20D90"]}
          />
        </SvgIcon>
      </Grid>

      <Grid item xs={10} alignItems={"center"}>
        <Grid item xs={12}>
          <Typography variant="label-bold" noWrap={noWrap}>
            {title}
          </Typography>
        </Grid>

        {description && (
          <Typography variant="label-regular" noWrap>
            {description}
          </Typography>
        )}

        {createdAt && (
          <Tooltip title={moment(new Date(createdAt)).format("DD/MM/yyyy, hh:mm a")} placement="right">
            <Typography variant="label-regular" noWrap className={styles.truncateText}>
              {moment(new Date(createdAt)).fromNow()}
            </Typography>
          </Tooltip>
        )}
      </Grid>
    </Grid>
  )
}
